import { ThunkDispatch } from 'redux-thunk';
import { Auth } from '@jg/auth';
import { Action } from 'redux';
import makeRequest from '@jg/http-client';
import { REQUEST, ERROR_MESSAGES } from '../../consts';
import { httpActions, apiActions } from '..';
import config from '../../config';
import { generateAuthHeaders, redirectByResponseStatus } from '../../utils';
import { IAppState } from '../../types/state.d';
import { getTeamGuid } from '../../selectors/apiSelectors';

const fetchMembersList = () => async (
  dispatch: ThunkDispatch<IAppState, void, Action>,
  getState: () => IAppState,
  auth: Auth,
) => {
  const resourceName = REQUEST.GET_MEMBERS_LIST;
  try {
    await auth.refreshAccessTokenIfExpired();
    const teamGuid = getTeamGuid(getState());
    dispatch(httpActions.httpRequestMade(resourceName));
    const response = await makeRequest(
      `${config.pagesAPI}v1/teams/${teamGuid}/members`,
      {
        extraHeaders: generateAuthHeaders(auth),
      },
    );
    if (response && !response.ok) {
      redirectByResponseStatus(response.status);
      throw new Error(ERROR_MESSAGES.GET_MEMBERS_LIST);
    }
    const data = await response.json();
    dispatch(apiActions.saveMembersListData(data));
    dispatch(httpActions.httpRequestSuccess(resourceName));
  } catch (error) {
    dispatch(httpActions.httpRequestError(resourceName, error));
    redirectByResponseStatus(error.status);
  }
};

export default fetchMembersList;
